import { render, staticRenderFns } from "./DashboardKi.vue?vue&type=template&id=06b93fbb&scoped=true&"
import script from "./DashboardKi.vue?vue&type=script&lang=ts&"
export * from "./DashboardKi.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardKi.vue?vue&type=style&index=0&id=06b93fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b93fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('06b93fbb', component.options)
    } else {
      api.reload('06b93fbb', component.options)
    }
    module.hot.accept("./DashboardKi.vue?vue&type=template&id=06b93fbb&scoped=true&", function () {
      api.rerender('06b93fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dashboard/DashboardKi.vue"
export default component.exports